export const Tentative = ({ ...opts }) => <span {...opts}>(tentative)</span>;
